<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row m-b-10">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('scoreAssessment.mainProgram')
          }}</label>
          <a-select
            v-model.number="model.acp_id"
            style="width: 100%"
            :options="acp_list"
          ></a-select>
          <div class="validate ts-text-xs" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row m-b-10">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('scoreAssessment.assessmentLevel')
          }}</label>
          <a-select
            v-model.number="model.sc_ass_id"
            style="width: 100%"
            :options="scoreAssessmentLevel"
          ></a-select>
          <div class="validate ts-text-xs" v-if="errors.has('sc_ass_id')">
            {{ errors.first('sc_ass_id') }}
          </div>
        </div>
      </div>
      <div class="row m-b-10">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('scoreAssessment.assessmentBase')
          }}</label>
          <a-select
            v-model.number="model.sc_bas_id"
            style="width: 100%"
            :options="scoreAssessmentBase"
          ></a-select>
          <div class="validate ts-text-xs" v-if="errors.has('sc_bas_id')">
            {{ errors.first('sc_bas_id') }}
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click="cancel">{{ $t('cancel') }}</ts-button>
          <ts-button
            v-if="model.sc_setup_id == 0"
            class="mr-2"
            color="primary"
            outline
            :waiting="waiting_new"
            @click.prevent="onSaveAddNew"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button
            v-if="model.sc_setup_id == 0"
            color="primary"
            :waiting="waiting"
            @click.prevent="onSave"
            >{{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="model.sc_setup_id != 0"
            color="primary"
            :waiting="waiting"
            @click.prevent="onUpdate"
            >{{ $t('update') }}
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'formCreateAssessmentMain',
  props: ['editData'],
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      errors: new Errors(),
      acp_list: [],
      model: {
        sc_setup_id: 0,
        sc_ass_id: null,
        acp_id: null,
        sc_bas_id: null,
      },
    }
  },
  computed: {
    scoreAssessmentLevel() {
      return [
        {
          value: 1,
          label: 'Main Program',
        },
        {
          value: 2,
          label: 'Sub Program',
        },
        {
          value: 3,
          label: 'Level',
        },
        {
          value: 4,
          label: 'Grade',
        },
      ]
    },
    scoreAssessmentBase() {
      return [
        {
          value: 1,
          label: 'Component Base',
        },
        {
          value: 2,
          label: 'Subject bases',
        },
      ]
    },
  },
  created() {
    this.fetchMainProgram()
    this.setEdit()
  },
  methods: {
    ...mapActions('scoreAssessment', ['getMainProgram', 'store', 'update']),
    fetchMainProgram() {
      this.loading = true
      this.getMainProgram({
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign',
        },
        page: -1,
      })
        .then((response) => {
          this.acp_list = response.data.map((el) => ({
            value: el.acp_id,
            label: el.acp_name_foreign,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
          this.cancel()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      this.store(this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.errors = new Errors()
      this.waiting = true
      this.update({
        id: this.model.sc_setup_id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
          this.cancel()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    cancel() {
      this.$emit('cancel')
    },
    clearInput() {
      this.model.sc_setup_id = 0
      this.model.sc_ass_id = null
      this.model.acp_id = null
      this.model.sc_bas_id = null
    },
    setEdit() {
      if (this.editData != undefined && !_.isEmpty(this.editData)) {
        this.model = Object.assign(_.clone(this.editData))
      }
    },
  },
}
</script>
